
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toolbox",
      function () {
        return require("private-next-pages/toolbox.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toolbox"])
      });
    }
  